import { LocalDate } from "@flockcover/flock-svc-core-types"
import { BaseFleetEntry } from "../../../../api/fleet"
import { AddFleetEntryFormError } from "../../types"

// TODO test needed for this

export type AddFleetEntryFormState = {
  rows: ReadonlyArray<BaseFleetEntry>
  errors: ReadonlyArray<AddFleetEntryFormError>
}

export const makeInitialState = (rows: ReadonlyArray<BaseFleetEntry>): AddFleetEntryFormState => ({
  rows,
  errors: [],
})

type Data<T> = {
  index: number
  value: T
}

const updateRow = <T>(rows: ReadonlyArray<BaseFleetEntry>, data: Data<T>, key: keyof BaseFleetEntry) =>
  rows.map((row, i) =>
    i === data.index
      ? {
          ...row,
          [key]: data.value,
        }
      : row
  )

export type AddFleetEntryFormAction =
  | { type: "setVrn"; data: Data<string> }
  | { type: "setOnCoverDate"; data: Data<LocalDate | undefined> }
  | { type: "setOffCoverDate"; data: Data<LocalDate | undefined> }
  | { type: "setErrors"; errors: ReadonlyArray<AddFleetEntryFormError> }

export const addFleetEntryFormReducer = (
  state: AddFleetEntryFormState,
  action: AddFleetEntryFormAction
): AddFleetEntryFormState => {
  switch (action.type) {
    case `setVrn`:
      return {
        ...state,
        rows: updateRow<string>(state.rows, action.data, `registrationNumber`),
      }
    case `setOnCoverDate`:
      return {
        ...state,
        rows: updateRow<LocalDate | undefined>(
          state.rows,
          { index: action.data.index, value: action.data.value },
          `onCoverDate`
        ),
      }
    case `setOffCoverDate`:
      return {
        ...state,
        rows: updateRow<LocalDate | undefined>(
          state.rows,
          { index: action.data.index, value: action.data.value },
          `offCoverDate`
        ),
      }
    case `setErrors`:
      return {
        ...state,
        errors: action.errors,
      }
    default:
      return state
  }
}
